import React from "react";

interface ICountDownTimerProps {
    onAttemptTimeoutExpire: () => void;
    attemptTimeout: number;
}

type CountDownTimerProps = ICountDownTimerProps;

interface ICountDownTimerState {
    interval: number;
    counter: number;
}

class CountDownTimer extends React.Component<
    CountDownTimerProps,
    ICountDownTimerState
> {
    constructor(props: CountDownTimerProps) {
        super(props);
        this.tick = this.tick.bind(this);
        this.state = {
            counter: props.attemptTimeout,
            interval: 1,
        };
    }
    public componentDidMount() {
        this.setState({
            counter: this.props.attemptTimeout,
            interval: window.setInterval(this.tick, 1000),
        });
    }

    public componentDidUpdate() {
        if (this.state.counter === 0) {
            this.props.onAttemptTimeoutExpire();
        }
    }
    public componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    private tick() {
        const { counter } = this.state;
        if (counter && counter !== 0) {
            this.setState({
                counter: counter - 1,
            });
        }
    }

    public render() {
        return <span style={{ color: "#646363" }}>{this.state.counter}</span>;
    }
}

export default CountDownTimer;



// WEBPACK FOOTER //
// ./src/components/Timer/CountDownTimer.tsx